var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommentFormView = Marionette.View.extend({
    template: require('../../templates/comments/comment-form.html'),

    regions: {
        confirmationModal: '#yes-no-confirmation-modal'
    },

    childViewEvents: {
        'action:confirmed': 'saveConfirmed'
    },


    modelEvents: {
        change: 'render'
    },

    ui: {
        isInternal: "#is-internal",
        comment: '#text',
        cancel: '#cancel',
        send: '#send',

        confirmationModal: '#yes-no-confirmation-modal'
    },

    events: {
        'click @ui.isInternal': "validate",
        'keyup @ui.comment': "validate",

        'click @ui.send': 'onSend',
        'click @ui.cancel': 'onCancel'
    },

    templateContext: function () {
        return {}
    },

    initialize: function (options) {
        _.bindAll(this, 'sendComment');
        this.model = options.model;
        if (_.isUndefined(this.model.get("internal")))
            this.model.set("internal", false);
        this.dboId = options.dboId;
        this.utils = new CommonUtils();
    },

    onRender: function () {
        console.log(this.model.get("internal"));
        this.confirmationModal = new YesNoConfirmationModal({
            tag: 'comment-edit',
            message: "Editing the comment will effect the same comment in other entities. Are you sure you want to edit the comment?"
        });
        this.showChildView('confirmationModal', this.confirmationModal);
    },

    validate: function () {
        var id = this.model.get('id');
        if (_.isEmpty(id) && _.isEmpty(this.ui.comment.val())
            || this.ui.comment.val() === this.model.get('text') && this.ui.isInternal.prop("checked") === this.model.get('internal'))
            this.ui.send.attr("disabled", true);
        else
            this.ui.send.removeAttr("disabled");
    },

    onSend: function () {
        var id = this.model.get('id');

        if (_.isEmpty(id)) {
            this.sendComment();
        } else {
            this.confirmationModal.show();
        }
    },

    sendComment: function () {
        var that = this;
        var comment = that.ui.comment.val();
        if (_.isEmpty(comment))
            return;

        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/comment/' + that.dboId + "/" + (that.ui.isInternal.prop("checked") ? "internal" : "external"),
            data: comment,
            contentType: 'text/plain',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.triggerMethod('comment:added', response);
                    $.notify({
                        message: 'The comment added successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    updateComment: function () {
        var that = this;
        var comment = that.ui.comment.val();

        that.model.set('text', comment);
        that.model.set('internal', that.ui.isInternal.prop("checked"));
        that.model.unset('commentedBy', {silent: true});
        that.model.unset('editedBy', {silent: true});

        that.utils.showSpinner();
        $.ajax({
            type: "PUT",
            url: '/api/comment/' + that.dboId,
            data: JSON.stringify(that.model.attributes),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.triggerMethod('comment:updated', response);
                    $.notify({
                        message: 'The comment edited successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    onCancel: function () {
        this.triggerMethod('on:cancel:comment:send');
    },

    saveConfirmed: function (data) {
        if (data.tag === 'comment-edit' && data.result == true) {
            this.updateComment();
        }
        else {
            this.confirmationModal.hide();
        }
    }
});

module.exports = CommentFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/comments/comment-form.js
// module id = 266
// module chunks = 0